import axios from 'axios'
import { getAdminToken, clearAdminAuth } from '../utils/adminData.js'

const API_URL = import.meta.env.VITE_API_URL || ''

const adminApi = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor for adding admin auth token
adminApi.interceptors.request.use(
  (config) => {
    // Only add the token if Authorization header is not already set
    if (!config.headers.Authorization) {
      const token = getAdminToken()
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor for handling errors
adminApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized access - clear admin auth data
      clearAdminAuth()
      // Redirect to admin login
      if (window.location.pathname.startsWith('/admin') && 
          !window.location.pathname.includes('/admin/login')) {
        window.location.href = '/admin/login'
      }
    }
    return Promise.reject(error)
  }
)

export default adminApi

